import { takeLatest, call, put } from "redux-saga/effects";
import {
  UPDATE_COMPETITOR_PROFILE_REQUEST,
  updateCompetitorProfileSuccess,
  updateCompetitorProfileFailure,
} from "../actions/updateCompetitorProfileActions";
import { updateCompetitorProfile } from "../../../services/accIqService";

function* updateCompetitorProfileSaga(action) {
  try {
    const {
      user_id,
      user_role,
      user_type,
      client,
      competitor,
      company_id,
      subdimensions,
      ksCompanies,
      industry,
      remove_subdimensions,
    } = action.payload;

    if (remove_subdimensions !== undefined) {
      yield call(
        updateCompetitorProfile,
        user_id,
        user_role,
        user_type,
        client,
        competitor,
        company_id,
        subdimensions,
        ksCompanies,
        industry,
        remove_subdimensions
      );
    } else {
      yield call(
        updateCompetitorProfile,
        user_id,
        user_role,
        user_type,
        client,
        competitor,
        company_id,
        subdimensions,
        ksCompanies,
        industry
      );
    }

    yield put(updateCompetitorProfileSuccess());
  } catch (error) {
    yield put(
      updateCompetitorProfileFailure(
        error?.response?.data?.message || "Failed to update competitor profile"
      )
    );
  }
}

export default function* updateCompetitorProfileWatcher() {
  yield takeLatest(
    UPDATE_COMPETITOR_PROFILE_REQUEST,
    updateCompetitorProfileSaga
  );
}
